import api from "./api";

const videoService = {
  // Video Category related
  getAllVideoCategory: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(
      `/admin/video_category?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`
    );
  },

  getSingleVideoCategory: (vcId) => {
    return api.get(`/admin/video_category/${vcId}`);
  },

  addVideoCategory: (payload) => {
    return api.post("/admin/video_category/", payload);
  },

  editVideoCategory: (vcId, payload) => {
    return api.put(`/admin/video_category/${vcId}`, payload);
  },

  updateVideoCategoryOrder: (payload) => {
    return api.put("/admin/video_category_order", payload);
  },

  // Video Quality related
  getAllVideoQuality: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(
      `/admin/video_quality?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`
    );
  },

  getSingleVideoQuality: (vqId) => {
    return api.get(`/admin/video_quality/${vqId}`);
  },

  addVideoQuality: (payload) => {
    return api.post("/admin/video_quality/", payload);
  },

  editVideoQuality: (vqId, payload) => {
    return api.put(`/admin/video_quality/${vqId}`, payload);
  },

  updateVideoQualityOrder: (payload) => {
    return api.put("/admin/video_quality_order", payload);
  },

  // Video Language related
  getAllVideoLanguage: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(
      `/admin/languages?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`
    );
  },

  getSingleVideoLanguage: (langId) => {
    return api.get(`/admin/languages/${langId}`);
  },

  addVideoLanguage: (payload) => {
    return api.post("/admin/languages/", payload);
  },

  editVideoLanguage: (langId, payload) => {
    return api.post(`/admin/languages/update/${langId}`, payload);
  },

    getAllVideoShow: (payload = {}) => {
      const {
        perPage = "10",
        currentPage = "1",
        searchText = "",
        genre_list = [],
        rating_list = [],
        tag_list = [],
        mscategory_list = [],
        has_movie_file,
        has_subtitle_file,
        has_trailer,
        has_clip,
      } = payload;

      const params = new URLSearchParams();

      params.append("perPage", perPage);
      params.append("currentPage", currentPage);

      if (searchText) params.append("search", searchText);
      if (genre_list.length > 0) params.append("genre_list", genre_list.join(","));
      if (rating_list.length > 0) params.append("rating_list", rating_list.join(","));
      if (tag_list.length > 0) params.append("tag_list", tag_list.join(","));
      if (mscategory_list.length > 0) params.append("mscategory_list", mscategory_list.join(","));
      if (has_movie_file) params.append("has_movie_file", has_movie_file);
      if (has_subtitle_file) params.append("has_subtitle_file", has_subtitle_file);
      if (has_trailer) params.append("has_trailer", has_trailer);
      if (has_clip) params.append("has_clip", has_clip);

      const queryString = params.toString();
      const url = `/admin/video_show${queryString ? `?${queryString}` : ""}`;

      return api.get(url);
    },
    
  getSingleVideoShow: (videoShowId) => {
    return api.get(`/admin/video_show/${videoShowId}`);
  },

  exportAllVideoShowsExcel: () => {
    return api.get(`/admin/video_show/export-all`, {
      responseType: "blob",
      timeout: 300000,
    });
  },

  addVideoShow: (payload) => {
    return api.post("/admin/video_show/", payload);
  },

  editVideoShow: (videoShowId, payload) => {
    return api.put(`/admin/video_show/${videoShowId}`, payload);
  },

  deleteVideoShow: (videoShowId) => {
    return api.delete(`/admin/video_show/${videoShowId}`);
  },

  getAllVideoRatings: (payload = {}) => {
    const { perPage = "10", currentPage = "1", searchText = "" ,isAll = false} = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);
    if (searchText) params.append("search", searchText);
    if (isAll) params.append("isAll", isAll);
    const queryString = params.toString();
    const url = `/admin/video_rating${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  getSingleVideoRating: (vrId) => {
    return api.get(`/admin/video_rating/${vrId}`);
  },

  addVideoRating: (payload) => {
    return api.post("/admin/video_rating/", payload);
  },

  editVideoRating: (vrId, payload) => {
    return api.put(`/admin/video_rating/${vrId}`, payload);
  },

  // Upload related
  getUploadUrl: () => {
    return api.get("/admin/get-upload-url");
  },

  getSrtUploadUrl: () => {
    return api.get("/admin/subtitles/upload");
  },

  uploadVideoToS3: (payload) => {
    return api.post("/admin/upload-video", payload);
  },

  uploadSrtToS3: (payload) => {
    return api.post("/admin/upload/subtitle", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getWatches: (payload) => {
    const { startDate, endDate, selectedMovie } = payload || {};
    const movieParam =
      Array.isArray(selectedMovie) && selectedMovie.length > 0
        ? `&movie_id=${encodeURIComponent(selectedMovie.join(","))}`
        : "";
    const url = `/video/get-save-watched-user?startDate=${startDate}&endDate=${endDate}${movieParam}`;
    return api.post(url, payload);
  },
};

export default videoService;
